module.exports = ".button {\n  outline: none;\n  border: none;\n  background-color: #88671f;\n  width: 150px;\n  color: #fff;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.required {\n  &::after {\n    content: \" *\";\n    color: red;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/add-partner/add-partner.component.css
// module id = ./src/app/main-settings/add-partner/add-partner.component.css
// module chunks = main